import styled from "styled-components";

export const Aside = styled.div`
  height: 100vh;
  width: 100%;
  background-color: var(--beige-pastel);

  display: flex;
  justify-content: center;
  align-items: center;

  img {
    width: 100%;
    max-width: 560px;
  }
`;
